import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IndTabsDataModel } from '@omni/models/ind-tabs-data-model';

/**
 * Reusable header tab bar: horizontal row of buttons with active state.
 * Use when you need a simple tab bar at the top of a page (e.g. allocation Orders / Shipments / Inventory).
 */
@Component({
  selector: 'ind-header-tabs',
  templateUrl: 'ind-header-tabs.html',
  styleUrls: ['ind-header-tabs.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndHeaderTabsComponent {
  @Input() tabs: IndTabsDataModel[];
  @Input() selectedTab: string;
  @Output() tabChange = new EventEmitter<string>();

  onTabClick(value: string) {
    this.tabChange.emit(value);
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
